import type { FeatureMiddleware } from '@cast/api-client';

import { handleOpDemoInterceptor } from '../utils';

export const optimization: FeatureMiddleware<'optimization'> = {
  listClusterOptimizations: (args) =>
    handleOpDemoInterceptor({ ...args, opDemoFallback: { items: [] } }),
};
